import Vue from 'vue';
import Vuex from 'vuex';
import { app } from '@/store/app/app';
import { dashboard } from '@/store/dashboard/dashboard';
import { getModule } from 'vuex-module-decorators';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    dashboard
  },
});

export default store;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const resolveModule = (module: any): any => getModule(module, store);
